import { DatePicker as DatePickerAD, type DatePickerProps } from 'antd';
import cn from 'classnames';
import styles from './date-picker.module.css';
import type { DatePickerDateType } from './date-utilities';
import { useGetDatePickerFormat, useIsTwelveHourFormat } from './hooks';

export type DatePickerProperties<ValueType = DatePickerDateType, IsMultiple extends boolean = false> = {
  fullWidth?: boolean;
} & DatePickerProps<ValueType, IsMultiple>;

const DatePicker = <ValueType = DatePickerDateType, IsMultiple extends boolean = false>({
  className,
  fullWidth,
  showTime,
  ...props
}: DatePickerProperties<ValueType, IsMultiple>) => {
  const getDatePickerFormat = useGetDatePickerFormat();
  const isTwelveHourFormat = useIsTwelveHourFormat();

  return (
    <DatePickerAD<ValueType, IsMultiple>
      className={cn(className, { [styles['full-width'] ?? '']: fullWidth })}
      format={showTime ? getDatePickerFormat('defaultDateTimeFormat') : getDatePickerFormat('defaultDateFormat')}
      showTime={
        showTime
          ? {
              format: getDatePickerFormat('defaultTimeFormat'),
              showSecond: false,
              use12Hours: isTwelveHourFormat,
              ...(typeof showTime === 'object' ? showTime : {}),
            }
          : undefined
      }
      size="large"
      {...props}
    />
  );
};

export default DatePicker;
